var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{attrs:{"cols":"12","xl":_vm.content.columns}},[_c('b-card',{attrs:{"title":_vm.content.title}},_vm._l((_vm.content.texts),function(text,index){return _c('b-card-text',{key:`card-${index}`},[_c('div',{domProps:{"innerHTML":_vm._s(text)}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }